import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { MenuItem } from '@barboxx/models';

const COLUMNS: GridColDef<MenuItem.SearchResponse>[] = [
    { field: 'id', headerName: 'Id', width: 70 },
    {
        field: 'business.place.name',
        headerName: 'Business',
        width: 150,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'name',
        headerName: 'Name',
        sortable: false,
        flex: 1,
        width: 200,
        valueGetter: (value, row) => {
            switch (row.type) {
                case 'StandardDrink':
                    return row.standardDrink?.name;
                case 'CustomDrink':
                    return row.customDrink?.name;
                case 'Product':
                    return row.product?.name;
            }
        },
    },
    { field: 'type', headerName: 'Type', width: 150 },

    {
        field: 'isActive',
        headerName: 'Is Active',
        width: 100,
        align: 'right',
        headerAlign: 'right',
        type: 'boolean',
    },
    {
        field: 'featuredItem',
        headerName: 'Featured',
        width: 100,
        align: 'right',
        headerAlign: 'right',
        type: 'boolean',
    },
];

interface Props {
    data: MenuItem[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function MenuItemTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Menu Items">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
